import React from 'react'
import './CardGalerieVirtuelle.css'
import { ExternalLink } from 'react-external-link';
import { useTranslation} from 'react-i18next';

const CardGalerieVirtuelle = (props) => {

    const { t } = useTranslation();
 
    return (
            
            <div className='cardArtistePrecisGV  text-dark scale-in-center'>
                <ExternalLink href={`${props.linkToUnity}`} >
                <div className=' rounded-lg mx-1 shadow-lg m-3'>
                    <div className="cardNew">

                        <div className="card-body">
                            <div>

                                <h5 className="card-title text-dark">
                                    {props.NameArtist} 
                                </h5>

                                <div className="bg-danger rounded-pill d-inline p-2 text-white m-1 ">
                                    {t(props.CategorieArtiste)}
                                </div>

                            </div>
                        </div>
                        

                        <div> 
                           
                                
                                <figure>
                                    <img  style={{backgroundImage: `url(${props.photoGV})`, height: 300+'px', width: 100+'%',  backgroundRepeat: 'no-repeat', left: 0,backgroundSize: 'cover' }} alt={props.altimg} />
                                </figure>
                                
                            
                        </div>
                    </div>
                </div>
            </ExternalLink>
            </div>
        
    )
}





export default CardGalerieVirtuelle


